import { ComponentType, FC } from 'react';
import { IFormField, SpeciesForm } from '../../../../api/dtos/dtos';
import { IFormFieldComponentProps } from '../types/FieldTypes';
import CustomFileInput from './custom-fields/CustomFileInput';
import CustomLocationButton from './custom-fields/CustomLocationButton';
import CustomNoticeMessage from './custom-fields/CustomNoticeMessage';
import CustomRedirectMessage from './custom-fields/CustomRedirectMessage';
import CustomRichTextEditor from './custom-fields/CustomRichTextEditor';
import CustomRegionsDropdown from './custom-fields/CustomRegionsDropdown';

interface IFormFieldCustomProps {
    field: IFormField
    form: SpeciesForm
}

/**
 * --- Default / Unknown Field Component ---
 */
const FormFieldUnknown: FC<IFormFieldComponentProps> = () => {
    return (
        <>
            Unknown Field Type
        </>
    );
};


const FormFieldCustom : FC<IFormFieldCustomProps> = ({
    field,
    form
}) => {

    //
    // -- Custom components
    const FormFieldComponentMapping: Record<string, ComponentType<IFormFieldComponentProps<any>>> = {
        ["fileInput"]: CustomFileInput,
        ["locationButton"]: CustomLocationButton,
        ["noticeMessage"]: CustomNoticeMessage,
        ["redirectMessage"]: CustomRedirectMessage,
        ["richTextEditor"]: CustomRichTextEditor,
        ["regionsDropDown"]: CustomRegionsDropdown
    }

    const Component = FormFieldComponentMapping[field.name!] ?? FormFieldUnknown;

    return (
        <Component field={field} form={form} />
    )
}

export default FormFieldCustom